// extracted by mini-css-extract-plugin
export default {"home":"style_home__H79NP","orbit":"style_orbit__X44Ee"};